import { useSuggestions } from "./hooks/useSuggestions";
import SuggestionList from "./components/SuggestionList";
import "./peopleyoumayknow.scss";

const Peopleyoumayknow = () => {
  const { suggestions, isLoading, error, handleAddFriend, isPending } = useSuggestions();

  return (
    <div className="peopleYouMayKnow">
      <SuggestionList 
        suggestions={suggestions}
        isLoading={isLoading}
        error={error}
        onAddFriend={handleAddFriend}
        isPending={isPending}
      />
    </div>
  );
};

export default Peopleyoumayknow;